import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/admin/auth.service';
import {Router} from '@angular/router';
import {IntegracionesService} from "../../services/admin/integraciones.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnInit, AfterViewInit {
  usuario;
  canal;

  constructor(private authService: AuthService, private router: Router,
              private integracionesService: IntegracionesService,
  ) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));

  }

  ngOnInit(): void {
    this.obtenerListaParametrosCanal();
  }

  ngAfterViewInit(): void {
    if ((window as any).feather) {
      (window as any).feather.replace();
    }
  }

  toggleMenuMovil(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if ((event as any).stopImmediatePropagation) {
      (event as any).stopImmediatePropagation();
    }

    const body = document.body;
    const isMobile = window.innerWidth < 1200;

    if (isMobile) {
      if (!body.classList.contains('vertical-overlay-menu')) {
        body.classList.remove('vertical-menu-modern');
        body.classList.add('vertical-overlay-menu');
      }

      const overlay = document.querySelector('.sidenav-overlay');
      const isOpen = body.classList.contains('menu-open');

      if (isOpen) {
        body.classList.remove('menu-open');
        body.classList.add('menu-hide');
        overlay?.classList.remove('show');
        if ((window as any).$?.app?.menu) {
          (window as any).$.app.menu.hidden = true;
          (window as any).$.app.menu.expanded = false;
        }
      } else {
        body.classList.remove('menu-hide', 'menu-collapsed');
        body.classList.add('menu-open');
        overlay?.classList.add('show');
        if ((window as any).$?.app?.menu) {
          (window as any).$.app.menu.hidden = false;
          (window as any).$.app.menu.expanded = true;
        }
      }
    } else {
      if ((window as any).$?.app?.menu) {
        (window as any).$.app.menu.toggle();
      }
    }
  }

  cerrarSesion() {
    this.authService.signOut();
  }

  obtenerListaParametrosCanal() {
    const datos = {
      page: 1,
      page_size: 1
    };
    this.integracionesService.obtenerListaIntegraciones(datos).subscribe((result) => {
      this.canal = result.data.find((item) => item.valor === this.usuario.usuario.canal);
    });
  }
}
